export default __webpack_public_path__ + "static/media/logo.b64e0e70.png";